import React, { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import { useMetadata } from '../../../../providers/MetadataContext';

function DealAssetTypeField({ value, setValue }) {
  const metadata = useMetadata();
  const [selected, setSelected] = useState(
    (metadata?.deal?.lists?.asset_types || []).find(
      (option) => option.entity_id === value
    )
  );

  const handleChange = (event, newValue) => {
    setSelected(newValue);
    setValue(newValue.entity_id);
  };

  return (
    <Box>
      <Autocomplete
        id='asset-type-field'
        options={metadata?.deal?.lists?.asset_types || []}
        value={selected}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        groupBy={(option) => option.group}
        renderInput={(params) => (
          <TextField {...params} label='Primary Asset Type' />
        )}
      />
    </Box>
  );
}

export default DealAssetTypeField;
